export default function(state=[], action){
    switch(action.type){
        case "TOKEN_ERROR": 
        console.log('inside reducer for token error ',action);
            return  { ...state, authenticationDetails: action.payload };
        default:
            return state;
    }
}